import React, { useEffect, useState } from "react";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import { NavLink, useNavigate } from "react-router-dom";
import { NavCategories } from "../../data/NavItem";
import tykoonlogo from "../../assets/Tykoon Sports 1.png";
import { useLocation } from "react-router-dom";
import { LuLogOut, LuX } from "react-icons/lu";
import { Logout } from "../../API/auth/SigninAction";
import toast from "react-hot-toast";
import Loader from "../Loader/Loader";
import { getSocket } from "../../socket/socket";

const Sidebar = () => {
  const location = useLocation();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const [Logoutloading, setLogoutLoading] = useState(false);
  const [unreadChatsCount, setUnReadChatCount] = useState(0);

  const liStyle = `w-[90%] mx-auto rounded-md py-2 pl-3 cursor-pointer mb-1 flex flex-row items-center gap-2 text-nowrap xl:gap-3 tracking-wide text-xs md:text-xs xl:text-sm xl:flex-row xl:items-center xl:justify-start font-light text-gray-700 hover:text-gray-900`;

  const handleLogout = async () => {
    setLogoutLoading(true);
    await Logout()
      .then((res) => {
        localStorage.removeItem("tykoon_access");
        localStorage.removeItem("tykoon_refresh");
        setLogoutLoading(false);
        navigate("/signin");
        toast.success("Successfully logout!");
      })
      .catch((e) => {
        localStorage.removeItem("tykoon_access");
        localStorage.removeItem("tykoon_refresh");
        setLogoutLoading(false);
        navigate("/signin");
        toast.success("Successfully logout!");
      });
  };
  useEffect(() => {
    const socket = getSocket();
    socket.on("unreadChatsCount", (count) => {
      setUnReadChatCount(count);
      return () => {
        socket.off("unreadChatsCount"); // Remove listener
      };
    });
  }, []);

  return (
    <React.Fragment>
      {/* Mobile menu button */}
      <button
        onClick={() => setIsDrawerOpen(!isDrawerOpen)}
        className="sm:hidden flex items-center gap-2 p-2 m-auto"
      >
        <span className="text-xl">☰</span>
      </button>

      {/* Mobile Drawer */}
      <Drawer
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        direction="left"
        style={{
          width: "200px",
        }}
      >
        <div className="overflow-y-auto max-h-screen">
          {/* Close Button */}
          <div className="flex justify-between items-center pl-4 pr-2 h-24 border-b">
            <div className="flex justify-center items-center w-full">
              <img
                src={tykoonlogo}
                alt="taykoon-logo"
                className="w-16 h-16 object-contain"
              />
            </div>
            <button
              onClick={() => setIsDrawerOpen(false)}
              className="text-xl text-gray-600 hover:text-black"
            >
              <LuX />
            </button>
          </div>

          {/* Scrollable Content */}
          <div className="flex flex-col flex-1">
            {NavCategories.map((category, categoryIndex) => (
              <div key={categoryIndex} className="mb-3">
                <h3 className="text-xs font-light text-gray-400 uppercase tracking-wider px-4 py-2">
                  {category.title}
                </h3>
                <ul className="space-y-1">
                  {category.items.map((item, itemIndex) => {
                    const cond = item.url === location.pathname;
                    return (
                      <li key={itemIndex}>
                        <NavLink
                          to={item.url}
                          className={`${liStyle} ${
                            cond
                              ? "bg-[--primary] text-white"
                              : "hover:bg-gray-100"
                          }`}
                          onClick={() => setIsDrawerOpen(false)} // Close drawer on link click
                        >
                          <div>{item.icon}</div>
                          <div
                            className="break-words font-light"
                            style={{ whiteSpace: "normal", wordBreak: "break-word" }}
                          >
                            {item.label}
                          </div>
                          {item.label === "Support" && unreadChatsCount ? (
                            <span className="ml-2 text-xs bg-red-800 text-white font-semibold py-0.5 px-2 rounded-full">
                              {unreadChatsCount}
                            </span>
                          ) : null}
                        </NavLink>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
            <div className="mt-4 pt-4 border-t border-gray-200">
              <li className={`${liStyle} text-red-600`} onClick={handleLogout}>
                <LuLogOut /> Logout
              </li>
            </div>
          </div>
        </div>
      </Drawer>

      {/* Desktop Sidebar */}
      <div className="hidden sm:block overflow-y-auto max-h-screen">
        <div className="flex items-center xl:gap-2 border-b-1 justify-center h-24 flex-col pt-1 xl:flex-row xl:pt-0">
          <div className="flex justify-between items-center px-4 h-14">
            <div className="flex justify-center items-center w-full">
              <img
                src={tykoonlogo}
                alt="taykoon-logo"
                className="w-full h-24 object-contain"
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col flex-1">
          {NavCategories.map((category, categoryIndex) => (
            <div key={categoryIndex} className="mb-3">
              <h3 className="text-xs font-light text-gray-400 uppercase tracking-wider px-4 py-2">
                {category.title}
              </h3>
              <ul className="space-y-1">
                {category.items.map((item, itemIndex) => {
                  const cond = item.url === location.pathname;
                  return (
                    <li key={itemIndex}>
                      <NavLink
                        to={item.url}
                        className={`${liStyle} ${
                          cond
                            ? "bg-[--primary] text-white"
                            : "hover:bg-gray-100"
                        }`}
                      >
                        <div className="text-[18px]">{item.icon}</div>
                        <div
                          className="break-words text-[13px] font-light"
                          style={{ whiteSpace: "normal", wordBreak: "break-word" }}
                        >
                          {item.label}
                        </div>

                        {item.label === "Support" && unreadChatsCount ? (
                          <span className="ml-2 text-xs bg-red-800 text-white font-semibold py-0.5 px-2 rounded-full">
                            {unreadChatsCount}
                          </span>
                        ) : null}
                      </NavLink>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
          <div className="mt-4 pt-4 border-t border-gray-200">
            <li
              className={`${liStyle} text-red-600 cursor-pointer relative`}
              onClick={handleLogout}
              disabled={Logoutloading} // Disable the button during loading
            >
              <LuLogOut />
              <span className="ml-2 relative">
                {Logoutloading && (
                  <span className="absolute inset-0 flex justify-center items-center">
                    <Loader />
                  </span>
                )}
                Logout
              </span>
            </li>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Sidebar;
